"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require("../../../mixins/colors");

//
//
//
//
//
//
//
//
//
//

var Chart = require("chart.js");
exports.default = {
  props: ["result", "groupName"],

  computed: {
    labels: function labels() {
      return {
        weight: this.$root.$t("tests.messages.inbody_weight"),
        smm: this.$root.$t("tests.messages.inbody_smm"),
        bfm: this.$root.$t("tests.messages.inbody_bfm"),
        pbf: this.$root.$t("tests.messages.inbody_pbf"),
        vfa: this.$root.$t("tests.messages.inbody_vfa")
      };
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.render();

    this.$store.subscribe(function (mutation) {
      if (mutation.type === "changeLocale") {
        _this.render();
      }
    });
  },


  methods: {
    render: function render() {
      var vm = this;
      var originalLineDraw = Chart.controllers.horizontalBar.prototype.draw;

      Chart.helpers.extend(Chart.controllers.horizontalBar.prototype, {
        draw: function draw() {
          originalLineDraw.apply(this, arguments);

          var chart = this.chart;
          var ctx = chart.chart.ctx;

          var index = chart.config.options.lineAtIndex;
          var value = chart.config.options.value;

          if (index) {
            var xaxis = chart.scales["x-axis-0"];
            var yaxis = chart.scales["y-axis-0"];

            var x1 = xaxis.getPixelForValue(index);
            var y1 = yaxis.top + 12;

            var x2 = xaxis.getPixelForValue(index);
            var y2 = yaxis.top + yaxis.height;

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.strokeStyle = "black";
            ctx.lineTo(x2, y2);
            ctx.stroke();

            ctx.fillStyle = "black";
            ctx.textAlign = "center";
            ctx.fillText(vm.$root.$t("tests.messages.inbody_result", { result: value }), x1, yaxis.top + 5);

            ctx.restore();
          }
        }
      });

      var options = {
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              return data["datasets"][tooltipItem["datasetIndex"]]["info"];
            }
          },
          displayColors: false,
          position: "nearest"
        },
        hover: {
          animationDuration: 0
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "'Open Sans Bold', sans-serif",
              fontSize: 11,
              min: this.result.min,
              max: this.result.max,
              stepSize: this.result.step
            },
            scaleLabel: {
              display: false
            },
            gridLines: {},
            stacked: true
          }],
          yAxes: [{
            gridLines: {
              display: false,
              color: "#fff",
              zeroLineColor: "#fff",
              zeroLineWidth: 0
            },
            ticks: {
              fontFamily: "'Open Sans Bold', sans-serif",
              fontSize: 11
            },
            afterFit: function afterFit(scaleInstance) {
              scaleInstance.width = 175;
            },
            stacked: true
          }]
        },
        legend: {
          display: true
        },
        lineAtIndex: this.result.valuePercent,
        value: this.result.value,

        pointLabelFontFamily: "Quadon Extra Bold",
        scaleFontFamily: "Quadon Extra Bold"
      };

      var chart = new Chart(this.$refs.canvas, {
        type: "horizontalBar",
        data: {
          labels: [this.groupName ? this.result.text + " (" + this.groupName + ")" : this.result.slug ? this.labels[this.result.slug] : this.result.text],

          datasets: [{
            data: [this.result.normalLowerPercent],
            info: ['pbf', 'vfa'].includes(this.result.type) ? "" : vm.$root.$t("tests.messages.inbody_normal_ranges", {
              minRange: this.result.normalLower,
              maxRange: this.result.normalUpper
            }),
            backgroundColor: _colors.CHART_BACKGROUND_COLOR,
            hoverBackgroundColor: _colors.CHART_BACKGROUND_COLOR_HOVER,
            label: vm.$root.$t("tests.messages.inbody_under") + (this.result.lower ? " (" + this.result.lower + ")" : '')
          }, {
            data: [this.result.normalUpperPercent - this.result.normalLowerPercent],
            info: vm.$root.$t("tests.messages.inbody_normal_ranges_percentages", {
              minRange: this.result.normalLowerPercent,
              maxRange: this.result.normalUpperPercent
            }),
            backgroundColor: _colors.CHART_MAIN_COLOR,
            hoverBackgroundColor: _colors.CHART_MAIN_COLOR_HOVER,
            label: vm.$root.$t("tests.messages.inbody_normal") + (this.result.normal ? " (" + this.result.normal + ")" : '')
          }, {
            data: [this.result.max - this.result.normalUpperPercent],
            info: +this.result.value > +this.result.normalUpper ? vm.$root.$t("tests.messages.inbody_result_over", {
              result: this.result.value
            }) : +this.result.value < +this.result.normalLower ? vm.$root.$t("tests.messages.inbody_result_under", {
              result: this.result.value
            }) : vm.$root.$t("tests.messages.inbody_result_normal", {
              result: this.result.value
            }),
            backgroundColor: _colors.CHART_BACKGROUND_COLOR,
            hoverBackgroundColor: _colors.CHART_BACKGROUND_COLOR_HOVER,
            label: vm.$root.$t("tests.messages.inbody_over") + (this.result.upper ? " (" + this.result.upper + ")" : '')
          }]
        },

        options: options
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/tests/InBody/InBodyHorizontalBar.vue
// module id = RqDA
// module chunks = 0 1